import { createStyles } from '@material-ui/core/styles';

export const menuListStyles = createStyles({
  root: {
    padding: '10px 0'
  }
});

const paperStyles = createStyles({
  root: {
    boxShadow: `0 1px 8px 0 rgba(69, 69, 69, 0.2),
     0 1px 6px 0 rgba(69, 69, 69, 0.1);`,
    minWidth: '120px'
  }
});

export default paperStyles;
